module.exports = __webpack_public_path__ + "img/guanwangurl.334022d3.png";